import React from "react";
import { DEAL_STAGES, DealStage } from "../lib/dealStages";

// Bulk select (#3079): the bar shown above the property list while select
// mode is on. The parent owns the selection and does the work; this only
// lays out the actions.

interface Props {
  count: number;
  /** How many rows "Select all" would pick (capped by the parent). */
  selectableCount: number;
  busy: boolean;
  onSelectAll: () => void;
  onClear: () => void;
  onDone: () => void;
  onWatch: () => void;
  onHide: () => void;
  /** Watchlist tab only. */
  onSetStage?: (stage: DealStage | null) => void;
  /** Paid plans only; omitted, no export button. */
  onExport?: () => void;
}

const BulkActionBar: React.FC<Props> = ({
  count,
  selectableCount,
  busy,
  onSelectAll,
  onClear,
  onDone,
  onWatch,
  onHide,
  onSetStage,
  onExport,
}) => {
  const none = count === 0;
  return (
    <div className="bulk-bar" role="toolbar" aria-label="Bulk actions">
      <span className="bulk-bar__count" aria-live="polite">
        {count} selected
      </span>
      {count < selectableCount ? (
        <button type="button" className="bulk-bar__link" onClick={onSelectAll} disabled={busy}>
          Select all {selectableCount}
        </button>
      ) : (
        !none && (
          <button type="button" className="bulk-bar__link" onClick={onClear} disabled={busy}>
            Clear
          </button>
        )
      )}
      <span className="bulk-bar__spacer" />
      <button type="button" className="bulk-bar__btn" onClick={onWatch} disabled={busy || none}>
        Watch
      </button>
      <button type="button" className="bulk-bar__btn" onClick={onHide} disabled={busy || none}>
        Not interested
      </button>
      {onSetStage && (
        <select
          className="bulk-bar__select"
          aria-label="Set deal stage for selected"
          value=""
          disabled={busy || none}
          onChange={(e) => {
            const v = e.target.value;
            if (v) onSetStage(v === "none" ? null : (v as DealStage));
          }}
        >
          <option value="">Set stage…</option>
          {DEAL_STAGES.map((s) => (
            <option key={s.value} value={s.value}>
              {s.label}
            </option>
          ))}
          <option value="none">No stage</option>
        </select>
      )}
      {onExport && (
        <button type="button" className="bulk-bar__btn" onClick={onExport} disabled={busy || none}>
          Export CSV
        </button>
      )}
      <button type="button" className="bulk-bar__link" onClick={onDone}>
        Done
      </button>
    </div>
  );
};

export default BulkActionBar;
